import React from 'react';
import Navbar from './Navbar/Navbar';
import MobileViewNavbar from './Navbar/mobileNavbar';
import Footer from './Footer/Footer';
import { useLocation } from '@reach/router';

import './Layout.css';
import Login from '../../pages/login/login';

const Layout = ({ children }) => {
  const location = useLocation(); // Use useLocation hook to get the location object
  const isMobile =
    typeof window !== 'undefined' && /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const isCasestudy = location.pathname.includes('case-study');
  const isLoginOrLogout =
    location.pathname.includes('login') || location.pathname.includes('logout');
  const isMicrosites = location.pathname.includes('microsites');
  return (
    <>
      <div className="layout">
        {!isLoginOrLogout && !isMicrosites && (isMobile ? <MobileViewNavbar /> : <Navbar />)}
        <main>{children}</main>
        {isCasestudy ? (
          <div className="casestudyFooter">
            <Footer />
          </div>
        ) : (
          ''
        )}
      </div>
    </>
  );
};

export default Layout;
